module.exports = __webpack_public_path__ + "assets/img/icon-1.e7c16062.png";